'use strict';

/**
 *
 * @name: nnXTopics
 *
 */

import DirectiveTemplate from './nn-mobile-app-banner.index.html';

function NnMobileAppBanner($localStorage, $rootScope) {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      var LOCAL_STORAGE_KEY = 'mobileAppBannerClosedAt';

      /**
       *
       * @PUBLIC
       *
       */

      scope.getApp = function($event){
        $event.preventDefault();

        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window.safari || (typeof safari !== 'undefined' && safari.pushNotification));

        if(isSafari){
          window.location = 'https://itunes.apple.com/cn/app/nowness-%E7%8E%B0%E5%9C%A8/id1335092252?mt=8';
          return
        }

        window.location.href = 'nownesscn://open';
        setTimeout(function () {
          window.location = window.location.origin + '/mobile';
        }, 25);

      };

      scope.onCloseClick = function($event) {
        $event.preventDefault();
        $localStorage[LOCAL_STORAGE_KEY] = new Date().getTime();
        _terminate();
      };

      /**
       *
       * @PRIVATE
       *
       */

      function init() {

        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf('android') > -1;

        if (!$rootScope.isMobileDevice || isAndroid) {
          _terminate();
        }
      }

      function _terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      /**
       *
       * @INIT
       *
       */

      init();
    }
  };
}

export default NnMobileAppBanner;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-mobile-app-banner/nn-mobile-app-banner.directive.js